import Vue from 'vue';

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/zh-TW";
Vue.use(ElementUI, { size: "medium", locale });